export { fetchDeviceConfiguration, FetchDeviceConfigurationArgs } from '../../phoenix';
